import React, { useState } from 'react';
import { base44 } from '@/api/base44Client';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { toast } from 'sonner';
import CategoryEditor from '@/components/admin/CategoryEditor';

const emptyCategory = { name: '', filter: 'Residenziale', media_type: 'image', image: '', video_url: '', image_meta: {}, order: 0 };
const slugify = (value) => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

export default function CategoriesManager() {
  const queryClient = useQueryClient();
  const [adding, setAdding] = useState(false);
  const { data: categories = [], isLoading } = useQuery({
    queryKey: ['category-images'],
    queryFn: () => base44.entities.CategoryImage.list('order'),
    staleTime: 0,
    refetchOnMount: 'always',
  });

  const saveMutation = useMutation({
    mutationFn: (category) => {
      if (!category.id) return base44.entities.CategoryImage.create({ ...category, category: `${slugify(category.name)}-${Date.now()}` });
      const { id, created_date, updated_date, created_by_id, ...changes } = category;
      return base44.entities.CategoryImage.update(id, changes);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['category-images'] });
      setAdding(false);
      toast.success('Categoria salvata');
    },
    onError: () => toast.error('Impossibile salvare la categoria'),
  });

  const deleteMutation = useMutation({
    mutationFn: (id) => base44.entities.CategoryImage.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['category-images'] });
      toast.success('Categoria eliminata');
    },
    onError: () => toast.error('Impossibile eliminare la categoria'),
  });

  const remove = (category) => {
    if (window.confirm(`Eliminare la categoria “${category.name}”?`)) deleteMutation.mutate(category.id);
  };

  return (
    <div>
      <div className="mb-6 flex items-center justify-between gap-4">
        <div><h2 className="text-xl font-serif">Categorie Homepage</h2><p className="mt-1 text-sm text-[#7a7a7a]">Gestisci nomi, immagini, ordine e metadati SEO.</p></div>
        <Button type="button" onClick={() => setAdding(true)} disabled={adding}><Plus className="mr-2 h-4 w-4" />Aggiungi</Button>
      </div>
      <div className="grid gap-6">
        {adding && <CategoryEditor key="new" initialValue={emptyCategory} isNew saving={saveMutation.isPending} onSave={(value) => saveMutation.mutate(value)} />}
        {isLoading ? <p className="text-sm text-[#7a7a7a]">Caricamento categorie...</p> : categories.map((category) => (
          <CategoryEditor key={`${category.id}-${category.updated_date}`} initialValue={category} saving={saveMutation.isPending} onSave={(value) => saveMutation.mutate(value)} onDelete={() => remove(category)} />
        ))}
        {!isLoading && !adding && categories.length === 0 && <p className="py-8 text-center text-sm text-[#7a7a7a]">Nessuna categoria presente.</p>}
      </div>
    </div>
  );
}